import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import MDBox from "../../MDBox";
import PropTypes from "prop-types";
import React, { useCallback, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import MDInput from "../../MDInput";
import VerbSearch from "./verb-search.js";
import TenseSelect from "./tense-select.js";
import { getTenseLabel } from "./data.js";

function Configurator({ params, onChange }) {
  const verbs = params.verbs || [];
  const tenses = params.tenses || [];

  useEffect(() => {
    if (!params.nbQuestions && params.nbQuestions !== 0) {
      onChange({ ...params, nbQuestions: 10 });
    }
  }, [!params.nbQuestions && params.nbQuestions !== 0]);

  const handleAddVerb = (verb) => {
    if (!verbs.includes(verb)) {
      onChange({
        ...params,
        verbs: verbs.concat([verb]),
      });
    }
  };

  const handleDeleteVerb = (verb) => {
    if (verbs.includes(verb)) {
      onChange({
        ...params,
        verbs: verbs.filter((v) => v !== verb),
      });
    }
  };

  const handleRemoveAllVerbs = useCallback(
    () =>
      onChange({
        ...params,
        verbs: [],
      }),
    [params]
  );

  const handleAddTense = (tense) => {
    if (!tenses.includes(tense)) {
      onChange({
        ...params,
        tenses: tenses.concat([tense]),
      });
    }
  };

  const handleDeleteTense = (tense) => {
    if (tenses.includes(tense)) {
      onChange({
        ...params,
        tenses: tenses.filter((v) => v !== tense),
      });
    }
  };

  const handleRemoveAllTenses = useCallback(
    () =>
      onChange({
        ...params,
        tenses: [],
      }),
    [params]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <VerbSearch onAdd={handleAddVerb} verbs={verbs} />
      </Grid>
      <Grid item xs={12}>
        <MDBox display="flex" alignItems="center" flexWrap="wrap">
          {!!verbs.length && (
            <MDBox
              sx={{
                border: "1px solid silver",
                borderRadius: 1,
                overflow: "hidden",
                display: "flex",
                flexDirection: "row",
                alignItems: "stretch",
                width: "100%",
              }}
            >
              <MDBox flex={1} p={1} sx={{ lineHeight: 2.4, maxHeight: 200, overflow: "auto" }}>
                {verbs.map((v) => (
                  <Chip key={v} label={v} onDelete={() => handleDeleteVerb(v)} sx={{ mx: 0.5 }} />
                ))}
              </MDBox>
              <MDBox
                sx={(theme) => ({
                  p: 1,
                  borderLeft: "1px solid silver",
                  "&:hover": {
                    backgroundColor: "#ffffaa",
                    color: theme.palette.error.main,
                  },
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                })}
                onClick={handleRemoveAllVerbs}
              >
                <DeleteIcon sx={{ width: 24, height: 24 }} />
              </MDBox>
            </MDBox>
          )}
        </MDBox>
      </Grid>
      <Grid item xs={12}>
        <TenseSelect onAdd={handleAddTense} tenses={tenses} />
      </Grid>
      <Grid item xs={12}>
        <MDBox display="flex" alignItems="center" flexWrap="wrap">
          {!!tenses.length && (
            <MDBox
              sx={{
                border: "1px solid silver",
                borderRadius: 1,
                overflow: "hidden",
                display: "flex",
                flexDirection: "row",
                alignItems: "stretch",
                width: "100%",
              }}
            >
              <MDBox flex={1} p={1} sx={{ lineHeight: 2.4, maxHeight: 200, overflow: "auto" }}>
                {tenses.map((v) => (
                  <Chip
                    key={v}
                    label={getTenseLabel(v)}
                    onDelete={() => handleDeleteTense(v)}
                    sx={{ mx: 0.5 }}
                  />
                ))}
              </MDBox>
              <MDBox
                sx={(theme) => ({
                  p: 1,
                  borderLeft: "1px solid silver",
                  "&:hover": {
                    backgroundColor: "#ffffaa",
                    color: theme.palette.error.main,
                  },
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                })}
                onClick={handleRemoveAllTenses}
              >
                <DeleteIcon sx={{ width: 24, height: 24 }} />
              </MDBox>
            </MDBox>
          )}
        </MDBox>
      </Grid>
      <Grid item xs={6}>
        <MDBox>
          <MDInput
            type="number"
            label="Nombre de questions"
            name="nbQuestions"
            InputProps={{
              inputProps: {
                min: 0,
                max: 50,
              },
            }}
            value={params.nbQuestions || 0}
            onChange={(e) => onChange({ ...params, nbQuestions: parseInt(e.target.value, 10) })}
            fullWidth
          />
        </MDBox>
      </Grid>
    </Grid>
  );
}
Configurator.propTypes = {
  params: PropTypes.object,
  onChange: PropTypes.func,
};

export default Configurator;
